import React from 'react';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';

const NamesStep = ({ formData, set }) => (
  <div className="space-y-4" data-testid="step-names">
    <h3 className="text-xl font-semibold mb-2 text-emerald-800">Proposed Company Names</h3>
    <p className="text-sm text-gray-600">
      Provide up to 3 proposed names. CIPC will check availability in order.
    </p>
    <div>
      <Label htmlFor="name1">First Choice Name *</Label>
      <Input
        id="name1"
        data-testid="proposed-name-1"
        value={formData.proposedName1}
        onChange={(e) => set('proposedName1', e.target.value)}
      />
    </div>
    <div>
      <Label htmlFor="name2">Second Choice Name</Label>
      <Input
        id="name2"
        data-testid="proposed-name-2"
        value={formData.proposedName2}
        onChange={(e) => set('proposedName2', e.target.value)}
      />
    </div>
    <div>
      <Label htmlFor="name3">Third Choice Name</Label>
      <Input
        id="name3"
        data-testid="proposed-name-3"
        value={formData.proposedName3}
        onChange={(e) => set('proposedName3', e.target.value)}
      />
    </div>
    <div>
      <Label htmlFor="activity">Main Business Activity *</Label>
      <textarea
        id="activity"
        data-testid="business-activity"
        value={formData.businessActivity}
        onChange={(e) => set('businessActivity', e.target.value)}
        className="mt-1 w-full p-2 border border-gray-300 rounded-md min-h-[100px]"
      />
    </div>
  </div>
);

export default NamesStep;
